import { AppDialog } from "@/components/common";
import { Button } from "@/components/ui/button";

const ConfirmDialog = ({
  open,
  onOpenChange,
  title,
  description,
  confirmLabel,
  cancelLabel,
  onConfirm,
  loading = false,
  tone = "default",
}) => {
  const confirmVariant = tone === "danger" ? "destructive" : "default";
  const titleColor = `text-${confirmVariant}`;

  return (
    <AppDialog
      open={open}
      onOpenChange={onOpenChange}
      title={<p className={titleColor}>{title}</p>}
      size="sm"
      footer={
        <>
          <Button
            variant="outline"
            onClick={() => onOpenChange?.(false)}
            disabled={loading}
          >
            {cancelLabel}
          </Button>
          <Button
            variant={confirmVariant}
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? "..." : confirmLabel}
          </Button>
        </>
      }
    >
      <p className="text-sm text-muted-foreground">{description}</p>
    </AppDialog>
  );
};

export default ConfirmDialog;
